import { useHotkeys } from 'react-hotkeys-hook';

import { usePlayerStore } from '../components/PlayerContextProvider';
import { usePlayerPlayPause } from './usePlayerPlayPause';

export type UsePlayerPlayPauseShortcutParams = {
  /**
   * The scope for the play/pause shortcut.
   * @see https://github.com/JohannesKlauss/react-hotkeys-hook?tab=readme-ov-file#scopes
   */
  scope: string;
};

export const usePlayerPlayPauseShortcut = ({ scope }: UsePlayerPlayPauseShortcutParams) => {
  const initialized = usePlayerStore((store) => store.initialized);
  const { onPlayerPlayPause } = usePlayerPlayPause();

  useHotkeys(
    'space,k',
    () => {
      onPlayerPlayPause();
    },
    {
      description: 'Toggle play/pause',
      enabled: initialized,
      preventDefault: true,
      scopes: [scope],
    },
    [initialized, scope, onPlayerPlayPause],
  );
};
